import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import { Event } from '../../../../../analytics/components';
import { DynamicFormContext } from '../../context/DynamicFormContext';
function DynamicFormSubmitButton() {
  var _useContext = useContext(DynamicFormContext),
    event = _useContext.event,
    submitButtonProps = _useContext.submitButtonProps,
    isFormDisabled = _useContext.isFormDisabled,
    initializeFormData = _useContext.initializeFormData,
    displayErrors = _useContext.displayErrors,
    isFormValid = _useContext.isFormValid,
    loading = _useContext.loading;
  var label = submitButtonProps.label,
    fluid = submitButtonProps.fluid;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isFormDisabled && /*#__PURE__*/React.createElement(Event, {
    eventType: "click",
    event: event
  }, /*#__PURE__*/React.createElement(Button, {
    primary: true,
    fluid: fluid,
    disabled: loading || displayErrors && !isFormValid
  }, label)), isFormDisabled && /*#__PURE__*/React.createElement(Button, {
    onClick: initializeFormData,
    primary: true,
    fluid: fluid
  }, "Send Another Message"));
}
export default DynamicFormSubmitButton;